/* Result Header with icon and name
 * Created on Wed Aug 30 2017
 *
 * Copyright (c) 2017 Ubiwhere
 *
 * Authors:
 * - Hugo Fonseca <hfonseca@ubiwhere.com>
 */

import React from 'react'
import styled from 'styled-components'

const CYCLES = {
  's': 'Simples',
  'b': 'Bi-horário',
  't': 'Tri-horário',
  'f': 'Tetra-horário'
}

/* eslint-disable camelcase */
const ResultHeader = ({ designation, absoluteLogoUrl, timeCycle }) => (
  <Header>
    {absoluteLogoUrl &&
    <Image>
      <img src={absoluteLogoUrl} alt={designation} />
    </Image>
      }
    <Name>{designation} - {CYCLES[timeCycle]}</Name>
  </Header>
)
/* eslint-enable camelcase */

export default ResultHeader

const Header = styled.div`
  background-color: rgba(255,255,255,0.6);
  border: 1px solid #EFEFEF;
  border-bottom: 0;
  height: 57px;
  display: flex;
  min-width: 200px;
  max-width: 700px;
  align-items: center;
`

const Image = styled.div`
  width: 149px;
  border-right: 1px solid #EFEFEF;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-height: 60%;
    max-width: 80%;
  }

`

const Name = styled.div`
  font-size: 16px;
  color: #676767;
  line-height: 24px;
  font-weight: bold;
  text-align: left;
  padding: 16px;

  @media(max-width: 1280px) {
    font-size: 14px;
  }
`



// WEBPACK FOOTER //
// ./src/components/ResultHeader/index.js